import './home.css'
import dritero from '../../assets/company/dritero.jpg'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import arrow from '../../assets/home/arrow.png'
import { useState, useEffect } from 'react';

const companies = [
    "Adecco Group", "Air Liquide", "Anvis Group", "Audi", "AVL Schrick",
    "Benteler International", "Bethmann Bank", "BP Europa SE", "Caldic", "Coresystems (SAP)",
    "CTS Eventim", "Deutsche Bahn", "XALT Energy", "E.ON", "Airbus",
    "EnBW", "Evonik Industries", "Faurecia", "Magna International", "Köppern Maschinenfabrik",
    "LenioBio", "Logicalis", "MBtech Group", "Nidec Corporation", "Plastic Omnium",
    "Porsche", "Riedel Communications", "Roche Diagnostics", "Schenker", "SEAT",
    "Škoda", "Solaris Bus & Coach", "T-Systems International", "TMD Frictions", "TÜV Süd",
    "UFI Filters", "Veolia", "Vitrulan Textilglas", "Volkswagen"
];

export default function Home() {
    const [mobileVersion, setMobileVersion] = useState(window.innerWidth <= 767);
    const [projects, setProjects] = useState(0);
    const [customers, setCustomers] = useState(0);
    const [countries, setCountries] = useState(0);
    const [industries, setIndustries] = useState(0);
    const [yearsOfExperience, setYearsOfExperience] = useState(0);

    useEffect(() => {
        function handleResize() {
            setMobileVersion(window.innerWidth <= 767);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    // Count animation logic
    useEffect(() => {
        const duration = 2000; // Duration of animation in milliseconds
        const targetValues = [500, 80, 17, 15, 16];
        const setValues = [setProjects, setCustomers, setCountries, setIndustries, setYearsOfExperience];

        targetValues.forEach((target, idx) => {
            const intervalTime = duration / target; // Calculate interval time to sync counts
            let currentValue = 0;

            const interval = setInterval(() => {
                if (currentValue < target) {
                    currentValue++;
                    setValues[idx](currentValue);
                } else {
                    clearInterval(interval);
                }
            }, intervalTime);
        });

    }, []);

    return (
        <div className={mobileVersion ? 'mob-home' : 'home'}>
            <div className={mobileVersion ? 'mob-home-txt' : 'home-txt'}>A boutique for professional and executive search with a highly individual and personal approach.</div>
            {mobileVersion ? (
                <div className='mob-first-section'>
                    <div className={mobileVersion ? 'mob-dritero' : 'dritero'}>
                        <img src={dritero} />
                    </div>
                    <div className="mobile-statistics">
                        <div className="box">{projects} <br /> PROJECTS</div>
                        <div className="box">{customers} <br /> CUSTOMERS</div>
                        <div className="box">{countries} <br /> COUNTRIES</div>
                        <div className="box">{industries} <br /> INDUSTRIES</div>
                        <div className="box">{yearsOfExperience} <br /> YEARS OF EXPERIENCE</div>
                    </div>
                </div>
            ) : (
                <div className='first-section'>
                    <div className="statistics">
                        <div className="row">
                            <div className="box">
                                <p className='number'>{projects}</p>
                                <p className='text'>PROJECTS</p>
                            </div>
                            <div className="box">
                                <p className='number'>{customers}</p>
                                <p className='text'>CUSTOMERS</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="box">
                                <p className='number'>{countries}</p>
                                <p className='text'>COUNTRIES</p>
                            </div>
                            <div className="box">
                                <p className='number'>{industries}</p>
                                <p className='text'>INDUSTRIES</p>
                            </div>
                        </div>
                        <div className="third-row">
                            <div className="box">
                                <p className='number'>{yearsOfExperience}</p>
                                <p className='text'>YEARS OF EXPERIENCE</p>
                            </div>
                        </div>
                    </div>
                    <div className="dritero">
                        <img src={dritero} />
                    </div>

                </div>
            )}
            <div className="text1v2">
                <p>
                    Our commitment doesn't end with the placement.
                    Our mission is to connect companies worldwide with top professionals and
                    executives to ensure sustainable growth and business stability. Through trusted,
                    precise, and tailored executive search solutions, we create partnerships that go far
                    beyond simply filling roles. With our replacement guarantee, we promise to always
                    act in the best interests of our clients - offering solutions that leave no room for
                    excuses.
                </p>
            </div>
            <div className="second-section">
                <div className="w-full max-w-2xl mx-auto">
                    <Swiper
                        modules={[Autoplay]}
                        autoplay={{
                            delay: 1000,
                            disableOnInteraction: false
                        }}
                        speed={3000}
                        loop={true}
                        spaceBetween={10}
                        slidesPerView={mobileVersion ? 2 : 6}
                    >
                        {companies.map((company, idx) => (
                            <SwiperSlide key={idx}>
                                <div className="w-full h-24 flex items-center justify-center text-center bg-white rounded-xl shadow-md text-lg font-semibold px-4">
                                    <p className='comp'>{company}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>

            <div className={mobileVersion ? 'mob-third-section' : 'third-section'}>
                <p>Why us?</p>
                <a className='redirect-about' href='/about'>
                    <p>Find out more</p>
                    <img className={mobileVersion && 'mob-arrow'} src={arrow} />
                </a>
            </div>
        </div>
    );
}
